'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

let _ = t => t,
    _t;

import { useSelector } from 'react-redux';
import styled from 'styled-components';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIImage from 'UIComponents/image/UIImage';
import UIList from 'UIComponents/list/UIList';
import UIButton from 'UIComponents/button/UIButton';
import H4 from 'UIComponents/elements/headings/H4';
import UIGrid from 'UIComponents/grid/UIGrid';
import UIGridItem from 'UIComponents/grid/UIGridItem';
import PERSON_BLOB from 'bender-url!pricing-pages-unified-ui/img/peopleBlobs/payments-smiling-person.png';
import breakpoint from '../../utils/responsiveBreakpoints';
import getUsageTracker from 'pricing-pages-lib/utils/getUsageTracker';
import { isAppAuthSelector } from 'pricing-pages-unified-ui/selectors/ConfigSelectors';
import { getInAppPaymentsUrl } from 'pricing-pages-lib/utils/urls';
import { PAYMENTS_LANDING_PAGE_URL } from 'pricing-pages-lib/utils/publicPageUrls';
const ResponsiveImage = styled(UIImage).withConfig({
  displayName: "HubSpotPayments__ResponsiveImage",
  componentId: "sc-2q1bis-0"
})(["", ""], breakpoint.tabletPortrait(_t || (_t = _`
    display: none !important;
  `)));

const HubSpotPayments = () => {
  const isAppAuth = useSelector(isAppAuthSelector);
  const learnMoreHref = isAppAuth ? getInAppPaymentsUrl() : PAYMENTS_LANDING_PAGE_URL;
  return /*#__PURE__*/_jsxs(UIGrid, {
    className: "m-y-15",
    children: [/*#__PURE__*/_jsx(UIGridItem, {
      size: {
        sm: 12,
        md: 6
      },
      className: "display-flex justify-end",
      children: /*#__PURE__*/_jsx(ResponsiveImage, {
        src: PERSON_BLOB,
        width: 584,
        height: 356,
        loading: "lazy"
      })
    }), /*#__PURE__*/_jsxs(UIGridItem, {
      size: {
        sm: 12,
        md: 6
      },
      className: "flex-column justify-center",
      children: [/*#__PURE__*/_jsx(H4, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "paymentsContent.title"
        })
      }), /*#__PURE__*/_jsxs(UIList, {
        styled: true,
        className: "p-left-4 m-y-6",
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: "paymentsContent.description1"
        }), /*#__PURE__*/_jsx(FormattedMessage, {
          message: "paymentsContent.description2"
        }), /*#__PURE__*/_jsx(FormattedMessage, {
          message: "paymentsContent.description3"
        }), /*#__PURE__*/_jsx(FormattedMessage, {
          message: "paymentsContent.description4"
        })]
      }), /*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsx(UIButton, {
          use: "tertiary",
          external: true,
          href: learnMoreHref,
          onClick: () => getUsageTracker().track('externalLinkClick', {
            name: 'payments-learn-more',
            url: learnMoreHref
          }),
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learnMoreButtonCTA"
          })
        })
      })]
    })]
  });
};

export default HubSpotPayments;